  (function () {
    if (window.__hlDescZoom) return;
    window.__hlDescZoom = true;

    var MAXSCALE = 4;
    var dialog = document.querySelector('.hl-dz');
    if (!dialog) return;
    var strip = dialog.querySelector('[data-dz-strip]');
    var dots = dialog.querySelector('[data-dz-dots]');
    var hint = dialog.querySelector('[data-dz-hint]');
    var prevBtn = dialog.querySelector('.hl-dz__nav--prev');
    var nextBtn = dialog.querySelector('.hl-dz__nav--next');
    var coarse = window.matchMedia('(hover:none)');

    /* KNOWN, NOT CHOSEN — the clientWidth test decides what prev/next can reach.
       clientWidth > 80 exists to drop icons, spacers and anything the layout has
       not sized yet. It also drops every image inside a COLLAPSED details card,
       because a closed <details> gives its contents clientWidth 0. When the
       description's cards rendered open, this strip spanned all of them; since
       they render closed (PDP work, 2026-09-11) it spans the lead plus whichever
       one card the shopper has open.

       Nothing breaks: the image that was clicked is by definition inside an open
       card, so it is always in the list and the lightbox always opens on it. What
       changed silently is the WALK — prev/next used to cross three open sections
       and now stops at the edge of the open one. Nobody decided that; it fell out
       of the collapse change. Left as it is in this pass rather than fixed blind,
       because the alternative (measuring naturalWidth, or opening the strip to
       closed cards) changes what the arrows mean and wants its own measurement.
       If you come here because prev/next "lost" images, this is why. */
    function sources() {
      return Array.prototype.slice.call(
        document.querySelectorAll('.hl-desc__body img, .hl-desc__lead img')
      ).filter(function (i) { return !i.closest('.hl-dz') && i.clientWidth > 80; });
    }

    /* The description's <img> is served at width=1200 and drawn at 421. Asking
       the CDN for a bigger derivative is the entire point of opening it —
       reusing the same src would enlarge the same soft file.

       The multiplier matters: this view magnifies to 2.5x, so a width chosen to
       fit the screen exactly runs out of pixels the moment anyone uses the
       feature, which on a dimension diagram is the whole reason they opened it.
       1.5x screen-pixels is the compromise — enough that a 2.5x magnification
       is still reading real detail rather than interpolation, without shipping a
       2048px file to a phone that will never leave fit-to-screen.

       Shopify caps the derivative at the master (1200 for these two), so on this
       product the request costs nothing extra. It also only generates a
       derivative on FIRST request — a width nobody has asked for before is
       ~500ms cold — so the number is rounded to a 256 step rather than being
       whatever this particular device happens to be, and the whole store shares
       a handful of warm sizes instead of one per screen width. */
    function bigSrc(img) {
      var src = img.currentSrc || img.src || '';
      var dpr = window.devicePixelRatio || 2;
      var want = Math.min(2048, Math.ceil(window.innerWidth * dpr * 1.5 / 256) * 256);
      return /[?&]width=\d+/.test(src)
        ? src.replace(/([?&]width=)\d+/, '$1' + want)
        : src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + want;
    }

    // ---- per-image magnification ----------------------------------------
    var state = null;   // {img, scale, tx, ty}

    function apply(settle) {
      if (!state) return;
      var img = state.img;
      img.classList.toggle('is-settling', !!settle);
      img.style.transform =
        'translate(' + state.tx + 'px,' + state.ty + 'px) scale(' + state.scale + ')';
      img.setAttribute('data-zoomed', state.scale > 1.01 ? '1' : '0');
      dialog.setAttribute('data-zoomed', state.scale > 1.01 ? '1' : '0');
      if (settle) setTimeout(function () { img.classList.remove('is-settling'); }, 260);
    }

    /* Keep the picture covering the window. Without a clamp a pan can throw the
       image off the side and leave the visitor holding a black screen with no
       obvious way back to it. */
    function clamp() {
      if (!state) return;
      var img = state.img;
      var w = img.offsetWidth * state.scale;
      var h = img.offsetHeight * state.scale;
      var vw = window.innerWidth;
      var vh = window.innerHeight;
      var minX = Math.min(0, vw - w) - (vw - img.offsetWidth) / 2;
      var maxX = Math.max(0, vw - w) - (vw - img.offsetWidth) / 2;
      var minY = Math.min(0, vh - h) - (vh - img.offsetHeight) / 2;
      var maxY = Math.max(0, vh - h) - (vh - img.offsetHeight) / 2;
      if (w <= vw) { state.tx = 0; } else { state.tx = Math.max(minX, Math.min(maxX, state.tx)); }
      if (h <= vh) { state.ty = 0; } else { state.ty = Math.max(minY, Math.min(maxY, state.ty)); }
    }

    function reset(settle) {
      if (!state) return;
      state.scale = 1; state.tx = 0; state.ty = 0;
      apply(settle);
    }

    function bind(img) {
      if (state && state.img === img) return;
      if (state) reset(false);
      state = { img: img, scale: 1, tx: 0, ty: 0 };
      apply(false);
    }

    /* Zoom about a point, so the thing under the cursor or the finger stays
       under it. Scaling about the centre instead is what makes a lightbox feel
       like it is fighting you. */
    function zoomAt(px, py, next) {
      if (!state) return;
      next = Math.max(1, Math.min(MAXSCALE, next));
      var img = state.img;
      var r = img.getBoundingClientRect();
      var ox = (px - r.left) / state.scale;
      var oy = (py - r.top) / state.scale;
      state.tx += ox * (state.scale - next);
      state.ty += oy * (state.scale - next);
      state.scale = next;
      clamp();
    }

    // ---- the strip -------------------------------------------------------
    function cellAt(i) { return strip.children[i]; }

    function activeIndex() {
      return Math.round(strip.scrollLeft / (strip.clientWidth || 1));
    }

    /* The one being opened plus its immediate neighbours, so a swipe never
       waits — and nothing further out is paid for until it is swiped towards. */
    function hydrate(i) {
      for (var k = i - 1; k <= i + 1; k++) {
        var cell = strip.children[k];
        if (!cell) continue;
        var im = cell.querySelector('img');
        var src = im && im.getAttribute('data-src');
        if (src) { im.src = src; im.removeAttribute('data-src'); }
      }
    }

    function markDots(i) {
      for (var k = 0; k < dots.children.length; k++) {
        dots.children[k].className = k === i ? 'is-on' : '';
      }
      prevBtn.disabled = i <= 0;
      nextBtn.disabled = i >= strip.children.length - 1;
      hydrate(i);
      var cell = cellAt(i);
      if (cell) bind(cell.querySelector('img'));
    }

    function build(startIndex) {
      var list = sources();
      strip.innerHTML = '';
      dots.innerHTML = '';
      list.forEach(function (img, i) {
        var cell = document.createElement('div');
        cell.className = 'hl-dz__item';
        var big = document.createElement('img');
        big.alt = img.alt || '';
        big.decoding = 'async';
        /* Every cell exists from the moment the dialog opens, so a naive build
           fetches the full-size version of every description image on one tap.
           `loading="lazy"` does NOT solve this — measured: all three still
           downloaded, because Chrome's lazy margin is ~1250px and the cells are
           433px apart along a horizontal strip, so every one of them counts as
           "nearly visible". The src is therefore withheld and hydrated by
           position instead. */
        big.setAttribute('data-src', bigSrc(img));
        cell.appendChild(big);
        strip.appendChild(cell);
        var d = document.createElement('i');
        if (i === startIndex) d.className = 'is-on';
        dots.appendChild(d);
      });
      dialog.setAttribute('data-many', list.length > 1 ? '1' : '0');
      hint.textContent = coarse.matches ? 'Double-tap to zoom' : 'Double-click or scroll to zoom';
      return list.length;
    }

    function go(delta) {
      reset(false);
      var i = Math.max(0, Math.min(strip.children.length - 1, activeIndex() + delta));
      strip.scrollTo({ left: i * strip.clientWidth, behavior: 'smooth' });
    }

    function open(index) {
      if (!build(index)) return;
      Array.prototype.forEach.call(document.querySelectorAll('dialog[open]'), function (d) {
        if (d !== dialog) { try { d.close(); } catch (e) {} }
      });
      dialog.setAttribute('data-zoomed', '0');
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      strip.scrollLeft = index * strip.clientWidth;
      markDots(index);
      hint.style.opacity = '';
    }

    function close() {
      reset(false);
      state = null;
      dialog.setAttribute('data-zoomed', '0');
      try { dialog.close(); } catch (e) {}
      document.documentElement.style.overflow = '';
    }

    strip.addEventListener('scroll', function () {
      if (dialog.getAttribute('data-zoomed') === '1') return;
      markDots(activeIndex());
    }, { passive: true });

    dialog.querySelector('.hl-dz__close').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    // Clicking the black beside the picture closes, the way a lightbox should.
    // Only while unmagnified — once zoomed, that ground is the image's own
    // padding and a stray click there would throw away the visitor's position.
    strip.addEventListener('click', function (e) {
      if (e.target === strip || e.target.classList.contains('hl-dz__item')) {
        if (dialog.getAttribute('data-zoomed') !== '1') close();
      }
    });

    // ---- pointer: double-tap / double-click to zoom, drag to pan ----------
    var lastTap = 0, panning = false, moved = false, sx = 0, sy = 0, ox = 0, oy = 0;
    var pointers = {}, pinchStart = 0, pinchScale = 1;

    strip.addEventListener('pointerdown', function (e) {
      if (!state || e.target.tagName !== 'IMG') return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        pinchStart = Math.hypot(a.x - b.x, a.y - b.y);
        pinchScale = state.scale;
        panning = false;
        return;
      }
      if (state.scale > 1.01) {
        panning = true; moved = false;
        sx = e.clientX; sy = e.clientY; ox = state.tx; oy = state.ty;
        try { e.target.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });

    strip.addEventListener('pointermove', function (e) {
      if (!state) return;
      if (pointers[e.pointerId]) { pointers[e.pointerId].x = e.clientX; pointers[e.pointerId].y = e.clientY; }
      var ids = Object.keys(pointers);
      if (ids.length === 2 && pinchStart) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        zoomAt((a.x + b.x) / 2, (a.y + b.y) / 2, pinchScale * (d / pinchStart));
        apply(false);
        e.preventDefault();
        return;
      }
      if (!panning) return;
      moved = true;
      state.tx = ox + (e.clientX - sx);
      state.ty = oy + (e.clientY - sy);
      clamp();
      apply(false);
      e.preventDefault();
    });

    function endPointer(e) {
      delete pointers[e.pointerId];
      if (Object.keys(pointers).length < 2) pinchStart = 0;
      panning = false;
    }
    strip.addEventListener('pointerup', endPointer);
    strip.addEventListener('pointercancel', endPointer);

    strip.addEventListener('click', function (e) {
      if (e.target.tagName !== 'IMG' || !state) return;
      if (moved) { moved = false; return; }
      var now = Date.now();
      var isDouble = now - lastTap < 320;
      lastTap = now;
      if (!coarse.matches) return;              // desktop uses dblclick + wheel
      if (!isDouble) return;
      if (state.scale > 1.01) { reset(true); }
      else { zoomAt(e.clientX, e.clientY, 2.5); apply(true); }
    });

    strip.addEventListener('dblclick', function (e) {
      if (e.target.tagName !== 'IMG' || !state || coarse.matches) return;
      e.preventDefault();
      if (state.scale > 1.01) { reset(true); }
      else { zoomAt(e.clientX, e.clientY, 2.5); apply(true); }
    });

    strip.addEventListener('wheel', function (e) {
      if (!state || !dialog.open || e.target.tagName !== 'IMG') return;
      e.preventDefault();
      zoomAt(e.clientX, e.clientY, state.scale * (e.deltaY < 0 ? 1.16 : 1 / 1.16));
      apply(false);
    }, { passive: false });

    // ---- entry point -----------------------------------------------------
    document.addEventListener('click', function (event) {
      var img = event.target.closest && event.target.closest('.hl-desc__body img, .hl-desc__lead img');
      if (!img || img.closest('.hl-dz')) return;
      // An image inside a link belongs to the link.
      if (img.closest('a')) return;
      var list = sources();
      var i = list.indexOf(img);
      /* NOT IN THE STRIP MEANS NOT OURS. sources() drops anything under 80px
         wide — icons, spacers, and every image inside a collapsed card — so a
         tap on one of those used to fall through to `open(0)` and enlarge
         photograph 1, a picture the shopper never touched. Leaving the tap
         alone is the honest answer, and preventDefault has moved below this so
         a tap we decline is not also a tap we swallow. */
      if (i < 0) return;
      event.preventDefault();
      open(i);
    });
  })();
